import React, { ReactElement } from 'react';
import { Route, Switch } from 'react-router-dom';
import withEnterpriseLayout from 'src/components/AppRoutes/Enterprise/withEnterpriseLayout';
import EnterpriseMealCreditList from 'src/components/oneCorp/features/MealCredit/components/MealCreditList/EnterpriseMealCreditList';
import { MealCreditPage } from 'src/components/oneCorp/features/MealCredit/components/MealCreditPage';
import { MealCreditPaths } from 'src/components/oneCorp/features/MealCredit/components/Routes/MealCreditPathsDictionary';

export const MealCreditRoutes = (): JSX.Element => {
  const MealCreditListPage = withEnterpriseLayout(EnterpriseMealCreditList);

  return (
    <Switch>
      <Route
        exact
        path={MealCreditPaths.base}
        component={(): ReactElement => (
          <MealCreditListPage pageTitle="Meal credits" useFluidContainer />
        )}
      />
      <Route
        path={MealCreditPaths.base}
        render={(): ReactElement => <MealCreditPage />}
      />
    </Switch>
  );
};
